import { Component, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';

export const HISTORICAL_VALUE_EVENT = 'historicalValueEvent';

@Component({
	selector: 'cv-invision-historical-values',
	templateUrl: './historical-values.component.html',
	styleUrls: ['./historical-values.component.scss']
})
export class HistoricalValuesComponent {
	isOpen: boolean;
	historical: Array<any>;
	fromEvent: boolean;
	arrowTop: boolean;
	@ViewChild('historicalEle', { static: true }) historicalEle: ElementRef;
	constructor(private broadcastService: BroadcastService, private renderer: Renderer2) {
		this.isOpen = false;
		this.historical = [];
		this.registerHistoricalValueListener();
	}

	/**
	 * Closes the dropdown menu is user clicks outside.
	 * @param $event: any
	 */

	close(): void {
		this.isOpen = false;
		this.historical = [];
	}

	/**
	 * set the position of the component base on parent
	 * @param pos
	 */
	setHistoricalPosition(pos: any): void {
		const { offsetHeight, offsetLeft, offsetTop, offsetWidth, scrollTop } = pos;
		let top = offsetTop + offsetHeight;
		const innerheight = offsetTop + this.historicalEle.nativeElement.clientHeight;
		// center pos
		const left = offsetLeft - offsetWidth - 40;
		if (scrollTop) {
			top = top - scrollTop;
		}

		this.arrowTop = true;
		if (innerheight + 100 > window.innerHeight) {
			// if the total innerheight i greater than the container height put a botoom arrow
			this.arrowTop = false;
			const scroll = scrollTop || 0;
			top = offsetTop - this.historicalEle.nativeElement.clientHeight - offsetHeight - scroll;
		}

		if (this.historicalEle) {
			this.renderer.setStyle(this.historicalEle.nativeElement, 'top', `${top}px`);
			this.renderer.setStyle(this.historicalEle.nativeElement, 'left', `${left}px`);
		}
	}

	/**
	 * Register Lister to Show/Hide the Loader
	 */
	private registerHistoricalValueListener(): void {
		this.broadcastService.on(HISTORICAL_VALUE_EVENT, (broadcast: BroadcastEventModel) => {
			this.isOpen = broadcast.event.isOpen;
			this.historical = broadcast.event.data;
			this.setHistoricalPosition(broadcast.event.pos);
			// if (this.isOpen) {
			// 	// give some time to render
			// 	setTimeout(() => {
			// 		this.setHistoricalPosition(broadcast.event.pos);
			// 	}, 100);
			// }
		});
	}
}
